<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-videos-left-pane">
      <div class="bmw-lg-videos-left-pane-nav-links">
        <div class="row bmw-no-gutter" style="margin-top: 15px">
          <a [routerLink]='["home"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='home'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='home'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='home')}">
            <div class="col-lg-1 bmw-no-gutter">
              <i class="material-icons dp48">home</i>
            </div>
            <div class="col-lg-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
              HOME
            </div>
          </a>
        </div>
        <div class="row bmw-no-gutter" style="margin-top: 15px">
          <a [routerLink]='["subscription"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='subscription'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='subscription'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='subscription')}">
            <div class="col-lg-1 bmw-no-gutter">
              <i class="material-icons dp48">video_library</i>
            </div>
            <div class="col-lg-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
              SUBSCRIPTIONS
            </div>
          </a>
        </div>
        <div class="row bmw-no-gutter" style="margin-top: 15px">
          <a [routerLink]='["watchlist"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='watchlist'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='watchlist'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='watchlist')}">
            <div class="col-lg-1 bmw-no-gutter">
              <i class="material-icons dp48">remove_red_eye</i>
            </div>
            <div class="col-lg-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
              WATCHLIST
            </div>
          </a>
        </div>
        <div class="row bmw-no-gutter" style="margin-top: 15px">
          <a [routerLink]='["history"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='history'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='history'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='history')}">
            <div class="col-lg-1 bmw-no-gutter">
              <i class="material-icons dp48">history</i>
            </div>
            <div class="col-lg-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
              HISTORY
            </div>
          </a>
        </div>
      </div>
      <div class="bmw-lg-videos-left-pane-subscriptions">
        <a routerLink='manage-subscription'>
          <div class="row bmw-no-gutter">
            <span style="font-weight: bold;text-decoration:underline">Subscriptions</span>
          </div>
        </a>
        <div *ngIf='!subscribedChannels || subscribedChannels?.length === 0' style="font-size: 13px; width:148px;color: #0000008f">You don't have any subscriptions yet</div>
        <div class="row bmw-no-gutter bmw-lg-left-pane-subscription-channel" (click)='broadcastChannelNumber(channel.channelNumber)'
          *ngFor='let channel of subscribedChannels'>
          <div class="bmw-lg-left-pane-subscription-channel-number" [ngClass]="{'bmw-active-class': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentChannel === channel.channelNumber), 'mini-active-class': APP_SETTINGS.isMINI === 'true' && (currentChannel === channel.channelNumber),'rr-active-class': APP_SETTINGS.isRollsRoyce === 'true' && (currentChannel === channel.channelNumber)}">
            {{channel.channelNumber}}
          </div>
          <a [routerLink]="['channel-info', channel.channelNumber]">
            <div class="bmw-lg-left-pane-subscription-channel-name" [ngStyle]="{'color': (currentChannel === channel.channelNumber) && APP_SETTINGS.isMINI === 'true' ? '#bf1a22' : 
          (currentRoute === channel.channelNumber) && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : (currentRoute === channel.channelNumber) && APP_SETTINGS.isRollsRoyce === 'true' ? '#281432':'#000000' }">
              {{channel.channelName}}
            </div>
          </a>
        </div>
        <div class="row bmw-no-gutter" style="margin-top:15px">
          <div class="col-lg-1 bmw-no-gutter">
            <i class="material-icons d48" style="font-size: 20px">add</i>
          </div>
          <div class="col-lg-11 bmw-no-gutter">
            <a style="font-size: 12px; margin-left: 5px" routerLink='channels'>Add Channels</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Only iPadPro and Medium size Desktop HTML5 Goes here... -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-videos-left-pane md">
      <div class="bmw-lg-videos-left-pane-nav-links">
        <div class="row bmw-no-gutter" style="margin-top: 15px">
          <a [routerLink]='["home"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='home'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='home'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='home')}">
            <div class="col-md-1 bmw-no-gutter">
              <i class="material-icons dp48">home</i>
            </div>
            <div class="col-md-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
              HOME
            </div>
          </a>
        </div>
        <div class="row bmw-no-gutter" style="margin-top: 15px">
          <a [routerLink]='["subscription"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='subscription'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='subscription'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='subscription')}">
            <div class="col-md-1 bmw-no-gutter">
              <i class="material-icons dp48">video_library</i>
            </div>
            <div class="col-md-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
              SUBSCRIPTIONS
            </div>
          </a>
        </div>
        <div class="row bmw-no-gutter" style="margin-top: 15px">
          <a [routerLink]='["watchlist"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='watchlist'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='watchlist'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='watchlist')}">
            <div class="col-md-1 bmw-no-gutter">
              <i class="material-icons dp48">remove_red_eye</i>
            </div>
            <div class="col-md-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
              WATCHLIST
            </div>
          </a>
        </div>
        <div class="row bmw-no-gutter" style="margin-top: 15px">
          <a [routerLink]='["history"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='history'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='history'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='history')}">
            <div class="col-md-1 bmw-no-gutter">
              <i class="material-icons dp48">history</i>
            </div>
            <div class="col-md-9 bmw-no-gutter" style="padding-left: 15px; font-size: 14px">
              HISTORY
            </div>
          </a>
        </div>
      </div>
      <div class="bmw-lg-videos-left-pane-subscriptions">
        <a routerLink='manage-subscription'>
          <div class="row bmw-no-gutter">
            <span style="font-weight: bold; text-decoration:underline">Subscriptions</span>
          </div>
        </a>
        <div *ngIf='!subscribedChannels || subscribedChannels?.length === 0' style="font-size: 13px; width:138px; color: #0000008f">You don't have any subscriptions yet</div>
        <div class="row bmw-no-gutter bmw-lg-left-pane-subscription-channel" *ngFor='let channel of subscribedChannels'>
          <div class="bmw-md-left-pane-subscription-channel-number" [ngClass]='{"active-class": currentRoute === channel.channelNumber}'>
            {{channel.channelNumber}}
          </div>
          <div class="bmw-md-left-pane-subscription-channel-name">
            <a [routerLink]="['channel-info', channel.channelNumber]" [ngStyle]="{'color': (currentRoute === channel.channelNumber) && APP_SETTINGS.isMINI=== 'true' ? '#bf1a22' : (currentRoute === channel.channelNumber) && (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : (currentRoute === channel.channelNumber) && APP_SETTINGS.isRollsRoyce === 'true' ? '#281432' : '#000000' }">{{channel.channelName}}</a>
          </div>
        </div>
        <div class="row bmw-no-gutter">
          <div class="col-md-1 bmw-no-gutter">
            <i class="material-icons d48" style="font-size: 20px">add</i>
          </div>
          <div class="col-md-11 bmw-no-gutter">
            <a style="font-size: 12px; margin-left: 5px" routerLink='channels'>Add Channels</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!--  Only Tablet or iPad HTML5 Goes here... -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs-video-nav-bar flex-container flex-align-center" *ngIf='hideTopNavbar'>
      <div class="flex">
        <a [routerLink]='["home"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true'&& (currentRoute==='home'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='home'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='home')}">
          <div>
            <i class="material-icons dp48" style="font-size: 20px">home</i>
          </div>
          <div class="bmw-xs-video-nav-bar-item">
            HOME
          </div>
        </a>
      </div>
      <div class="flex">
        <a [routerLink]='["subscription"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='subscription'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='subscription'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='subscription')}">
          <div>
            <i class="material-icons dp48" style="font-size: 20px">video_library</i>
          </div>
          <div class="bmw-xs-video-nav-bar-item">
            SUBSCRIPTIONS
          </div>
        </a>
      </div>
      <div class="flex">
        <a [routerLink]='["watchlist"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='watchlist'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='watchlist'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='watchlist')}">
          <div>
            <i class="material-icons dp48" style="font-size: 20px">remove_red_eye</i>
          </div>
          <div class="bmw-xs-video-nav-bar-item">
            WATCHLIST
          </div>
        </a>
      </div>
      <div class="flex" [ngClass]="{'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='history'), 'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='history'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='history')}">
        <a [routerLink]='["history"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='history'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='history'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='history')}">
          <div>
            <i class="material-icons dp48" style="font-size: 20px">history</i>
          </div>
          <div class="bmw-xs-video-nav-bar-item">
            HISTORY
          </div>
        </a>
      </div>
    </div>
    <!-- <div class="bmw-xs-video-nav-bar">
    <div class="col-sm-3 bmw-no-gutter" >
      <a [routerLink]='["watchlist"]' [routerLinkActive]="!(''|brandTypePipe) && (currentRoute==='home') ? 'bmw-active-link' : (''|brandTypePipe) && (currentRoute==='home') ? 'mini-active-link' : ''">
        <div>
          <i class="material-icons dp48" style="font-size: 20px">home</i>
        </div>
        <div class="bmw-xs-video-nav-bar-item">
          HOME
        </div>
      </a>
    </div>
    <div class="col-sm-3 bmw-no-gutter" >
      <a [routerLink]='["watchlist"]' [routerLinkActive]="!(''|brandTypePipe) && (currentRoute==='subscription') ? 'bmw-active-link' : (''|brandTypePipe) && (currentRoute==='subscription') ? 'mini-active-link' : ''">
        <div>
          <i class="material-icons dp48" style="font-size: 20px">video_library</i>
        </div>
        <div class="bmw-xs-video-nav-bar-item">
          SUBSCRIPTIONS
        </div>
      </a>
    </div>
    <div class="col-sm-3 bmw-no-gutter" style="margin-left: -5px" [ngClass]="{'bmw-active-link': (''|brandTypePipe) && (currentRoute==='watchlist'), 'mini-active-link': !(''|brandTypePipe) && (currentRoute==='watchlist')}">
      <a [routerLink]='["watchlist"]' [routerLinkActive]="!(''|brandTypePipe) && (currentRoute==='watchlist') ? 'bmw-active-link' : (''|brandTypePipe) && (currentRoute==='watchlist') ? 'mini-active-link' : ''">
        <div>
          <i class="material-icons dp48" style="font-size: 20px">remove_red_eye</i>
        </div>
        <div class="bmw-xs-video-nav-bar-item">
          WATCHLIST
        </div>
      </a>
    </div>
    <div class="col-sm-3 bmw-no-gutter" style="margin-left: -6px" [ngClass]="{'bmw-active-link': (''|brandTypePipe) && (currentRoute==='history'), 'mini-active-link': !(''|brandTypePipe) && (currentRoute==='history')}">
      <a [routerLink]='["history"]' [routerLinkActive]="!(''|brandTypePipe) && (currentRoute==='history') ? 'bmw-active-link' : (''|brandTypePipe) && (currentRoute==='history') ? 'mini-active-link' : ''">
        <div>
          <i class="material-icons dp48" style="font-size: 20px">history</i>
        </div>
        <div class="bmw-xs-video-nav-bar-item">
          HISTORY
        </div>
      </a>
    </div>
  </div> -->
  </div>
</div>

<!-- Only Mobile hTML5 goes here... -->

<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs-video-nav-bar flex-container" *ngIf='hideTopNavbar'>
      <div class="flex-17">
        <a [routerLink]='["home"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='home'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='home'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='home')}">
          <div>
            <i class="material-icons dp48" style="font-size: 20px">home</i>
          </div>
          <div class="bmw-xs-video-nav-bar-item">
            HOME
          </div>
        </a>
      </div>
      <div class="flex-30">
        <a [routerLink]='["subscription"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='subscription'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='subscription'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='subscription')}">
          <div>
            <i class="material-icons dp48" style="font-size: 20px">video_library</i>
          </div>
          <div class="bmw-xs-video-nav-bar-item">
            SUBSCRIPTIONS
          </div>
        </a>
      </div>
      <div class="flex-29" [ngClass]="{'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='watchlist'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='watchlist'), 'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='watchlist')}">
        <a [routerLink]='["watchlist"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='watchlist'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='watchlist'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='watchlist')}">
          <div>
            <i class="material-icons dp48" style="font-size: 20px">remove_red_eye</i>
          </div>
          <div class="bmw-xs-video-nav-bar-item">
            WATCHLIST
          </div>
        </a>
      </div>
      <div class="flex-24" >
        <a [routerLink]='["history"]' [ngClass]="{'mini-active-link': APP_SETTINGS.isMINI === 'true' && (currentRoute==='history'), 'rr-active-link' : APP_SETTINGS.isRollsRoyce === 'true' && (currentRoute==='history'), 'bmw-active-link': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') && (currentRoute==='history')}">
          <div>
            <i class="material-icons dp48" style="font-size: 20px">history</i>
          </div>
          <div class="bmw-xs-video-nav-bar-item">
            HISTORY
          </div>
        </a>
      </div>
    </div>
  </div>
</div>